import React from 'react';

const OgCard = () => (
  <div
    className="relative w-[1200px] h-[630px] bg-[#0a0908] overflow-hidden flex flex-col items-center justify-center text-center"
    style={{ fontFamily: "'Manrope', sans-serif" }}
  >
    <div
      aria-hidden="true"
      className="absolute left-1/2 top-1/2 -translate-x-1/2 -translate-y-1/2 w-[900px] h-[900px] rounded-full bg-[radial-gradient(circle,rgba(241,90,36,0.3)_0%,rgba(241,90,36,0.1)_40%,transparent_70%)]"
    />
    <div aria-hidden="true" className="absolute left-1/2 top-1/2 -translate-x-1/2 -translate-y-1/2 w-[520px] h-[520px] rounded-full border border-[#f15a24]/15" />
    <div aria-hidden="true" className="absolute left-1/2 top-1/2 -translate-x-1/2 -translate-y-1/2 w-[700px] h-[700px] rounded-full border border-[#f15a24]/10" />

    <img
      src="/dineora-icon.png"
      alt="DineOra app icon"
      className="relative w-[110px] h-[110px] rounded-[28px] shadow-[0_0_90px_rgba(241,90,36,0.45)] mb-8"
    />

    <p className="relative font-mono2 text-[13px] uppercase tracking-[0.5em] text-[#f15a24] mb-5">Coming soon</p>
    <h1 className="relative font-display font-medium text-[64px] leading-[1.08] text-[#f5f2ee] max-w-[900px]">
      The neighbourhood table,<br />in your pocket.
    </h1>
    <p className="relative mt-6 text-[20px] text-[#a8a29e]">Order direct. No middleman, no markups. — DineOra</p>

    <div className="absolute bottom-8 left-0 right-0 flex items-center justify-center">
      <p className="font-mono2 font-semibold tracking-[0.4em] text-[#71716b] text-lg flex items-center gap-1">
        DINE<span className="inline-block rounded-full border-[3px] border-[#f15a24] w-[14px] h-[14px] mx-0.5" />RA
        <span className="ml-3 tracking-normal text-[#52504b]">· dineora.ca</span>
      </p>
    </div>
  </div>
);

export default OgCard;
